const login = {
    email: '',
    password: ''
};

const SET_LOGIN_INFO = 'SET_LOGIN_INFO'

export const setLoginInfo = (login) => ({
    type: SET_LOGIN_INFO,
    payload: login,
});

const login_store = (state = login, action) => {
    switch (action.type) {
        case SET_LOGIN_INFO:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
};

export default login_store;
